import SessionStorage from '../../../../../../../../utils/SessionStorage';

export default function setCardInfo(validJSONResponse: any) {
    let cardData = {};
    try {
        cardData =
            validJSONResponse.ApplicationInformation[0].CardDesign &&
            validJSONResponse.ApplicationInformation[0].CardDesign.Cards
                ? validJSONResponse.ApplicationInformation[0].CardDesign.Cards
                : validJSONResponse.ApplicationInformation.CardDesign.Cards;
    } catch (e) {
        console.log('Card info not available');
    }
    SessionStorage.setObject('cardInfo', cardData);
}
